import history from "../history";
import {
  SSO_SIGN_IN,
  SSO_SIGN_OUT,
  USER_LOGIN,
  IS_AUTHENTICATED,
  FETCH_AVAILABLE_AID_YEARS,
  RESET_STUDENT,
  RESET_SCHOOL,
  RESET_GLOBAL,
  UPDATE_AID_YEAR,
  RESET_PERMISSIONS,
  FETCH_STUDENT,
  FETCH_INTERVIEW_LINKS_ALL,
  FETCH_INTERVIEW_LINKS,
  FETCH_SCHOOL,
  SET_DEFAULT_AID_YEAR,
  UPDATE_IS_CROSS_SCHOOL_SEARCH,
  RESET_TOGGLES
} from "./types";
import AuthAPI from "../apis/AuthAPI";
import AuthService from "../services/AuthService";
import SchoolService from "../services/SchoolService";
import StudentService from "../services/StudentService";
import AlertService from "../services/AlertService";
import { getSchoolInfo } from "./SchoolActions";
import { fetchIsirRecElementInfo } from "../actions/AdminActions";

export const ssoProfileLogin = (profile) => {
  return async (dispatch) => {
    let response = await AuthAPI.post("/sso/ssoLogout");
    if (response.message) {
      console.log(response.message);
    } else {
      dispatch({
        type: SSO_SIGN_OUT,
        payload: {
          isSignedIn: null,
          ssoUser: null,
          user: null,
          role: null
        },
      });
      dispatch({
        type: RESET_SCHOOL,
        payload: {
          isSignedIn: null,
          ssoUser: null,
          user: null,
          role: null
        },
      });
      dispatch({
        type: RESET_GLOBAL,
        payload: {
          isSignedIn: null,
          ssoUser: null,
          user: null,
          role: null
        },
      });
      dispatch({ type: RESET_STUDENT, payload: {} });
      dispatch({ type: RESET_PERMISSIONS, payload: {} });
      dispatch({ type: RESET_TOGGLES, payload: {} });
    }
    response = await AuthService.ssoProfileLogin(profile);
    if (response.message) {
      console.log(response.message);
    } else {
      dispatch({ type: SSO_SIGN_IN, payload: response });
    }

    let school = await SchoolService.getSchool(profile.defaultSchoolCode);
    if (school.message) {
      console.log(school.message);
    } else {
      dispatch({ type: FETCH_SCHOOL, payload: school });
    }

    response = await SchoolService.getAvailableAidYears(
      profile.defaultSchoolCode
    );
    if (response.message) {
      console.log(response.message);
    } else {
      dispatch({ type: FETCH_AVAILABLE_AID_YEARS, payload: response });
      dispatch({ type: SET_DEFAULT_AID_YEAR, payload: school.defaultAidYear });
      dispatch(fetchIsirRecElementInfo(school.defaultAidYear));
      dispatch({
        type: UPDATE_IS_CROSS_SCHOOL_SEARCH,
        payload: false
      });
    }

    history.push("/welcome");
  };
};

export const fetchCurrentSsoUser = () => {
  return async (dispatch) => {
    const response = await AuthService.getCurrentSsoUser();
    if (response.message) {
      console.log(response.message);
    } else {
      dispatch({ type: SSO_SIGN_IN, payload: response });
    }
  };
};

export const getAvailableAidYears = (schoolCode) => {
  return async (dispatch) => {
    let response = await SchoolService.getAvailableAidYears(schoolCode);
    if (response.message) {
      console.log(response.message);
    } else {
      dispatch({ type: FETCH_AVAILABLE_AID_YEARS, payload: response });
    }
  };
};

export const getUser = () => {
  return async (dispatch) => {
    let response = {};
    let profile = await AuthService.getCurrentSsoUser();
    if (profile.message) {
      console.log(profile.message);
    } else {
      dispatch({ type: SSO_SIGN_IN, payload: profile });
      let school = await SchoolService.getSchool(profile.profile.defaultSchoolCode);
      dispatch({ type: FETCH_SCHOOL, payload: school });

      response = await SchoolService.getAvailableAidYears(
        profile.profile.defaultSchoolCode
      );
      if (response.message) {
        console.log(response.message);
      } else {
        dispatch({ type: FETCH_AVAILABLE_AID_YEARS, payload: response });
        dispatch({ type: SET_DEFAULT_AID_YEAR, payload: school.defaultAidYear });
        dispatch(fetchIsirRecElementInfo(school.defaultAidYear));
        dispatch({
          type: UPDATE_IS_CROSS_SCHOOL_SEARCH,
          payload: false,
        });
      }
    }
  };
};

export const ssoSignOut = () => {
  return async (dispatch) => {
    history.push("/login");
    const response = await AuthAPI.post("/sso/ssoLogout");
    if (response.message) {
      console.log(response.message);
    } else {
      dispatch({
        type: SSO_SIGN_OUT,
        payload: {
          isSignedIn: null,
          ssoUser: null,
          user: null,
          role: null
        },
      });
      dispatch({
        type: RESET_SCHOOL,
        payload: {
          isSignedIn: null,
          ssoUser: null,
          user: null,
          role: null
        },
      });
      dispatch({
        type: RESET_GLOBAL,
        payload: {
          isSignedIn: null,
          ssoUser: null,
          user: null,
          role: null
        },
      });
      dispatch({ type: RESET_STUDENT, payload: {} });
      dispatch({ type: RESET_PERMISSIONS, payload: {} });
      dispatch({
        type: UPDATE_IS_CROSS_SCHOOL_SEARCH,
        payload: false
      });
      dispatch({ type: RESET_TOGGLES, payload: {} });
    }
  };
};

export const studentLoginPageAuthReset = () => {
  return async (dispatch) => {
    const response = await AuthAPI.post("/sso/ssoLogout");
    if (response.message) {
      console.log(response.message);
    } else {
      dispatch({
        type: SSO_SIGN_OUT,
        payload: {
          isSignedIn: null,
          ssoUser: null,
          user: null,
          role: null
        },
      });
      dispatch({
        type: RESET_GLOBAL,
        payload: {
          isSignedIn: null,
          ssoUser: null,
          user: null,
          role: null
        },
      });
      dispatch({ type: RESET_STUDENT, payload: {} });
      dispatch({ type: RESET_PERMISSIONS, payload: {} });
      dispatch({
        type: UPDATE_IS_CROSS_SCHOOL_SEARCH,
        payload: false
      });
      dispatch({ type: RESET_TOGGLES, payload: {} });
    }
  };
};

export const userLogin = (username, password, noPasswordCallback, isSubmittingCallback) => {
  return async (dispatch) => {
    try {
      AuthService.logout().then((x) => {
        dispatch({
          type: SSO_SIGN_OUT,
          payload: {
            isSignedIn: null,
            ssoUser: null,
            user: null,
            role: null
          },
        });
        dispatch({ type: RESET_STUDENT, payload: {} });
        dispatch({ type: RESET_TOGGLES, payload: {} });

        AuthService.userLogin(username, password, noPasswordCallback).then((loginResponse) => {
          if (loginResponse.isLocked) {
            history.push(`/forgotPassword`);
            AlertService.addErrorAlert("Password expired. Please reset your password.");
          } else {
            dispatch({ type: USER_LOGIN, payload: loginResponse });
            dispatch({ type: UPDATE_AID_YEAR, payload: loginResponse.aidYear });
            dispatch(fetchIsirRecElementInfo(loginResponse.aidYear));
            dispatch(getSchoolInfo(loginResponse.schoolCode));

            AuthService.isAuthenticated().then((response) => {
              if (response.message) {
                console.log(response.message)
              }
              else {
                dispatch({ type: IS_AUTHENTICATED, payload: response });
              }
            });


            AuthService.passedMFA().then((passedMFA) => {
              if (passedMFA !== "true" && passedMFA !== true) {
                history.push(`/mfa/${loginResponse.uuid}/${loginResponse.accountType}`);
              } else {
                history.push(`/userLanding/${loginResponse.uuid}/${loginResponse.accountType}`);
              }
            }).then(() => {
              if (isSubmittingCallback)
                {
                  isSubmittingCallback();
                }
            });
          }
        }).catch(() => {
          if (isSubmittingCallback)
          {
            isSubmittingCallback();
          }
        });
      })
    } catch (err) { 
      AlertService.addErrorAlert(err.message);
    }
  };
};

export const setUserFullName = (user, fullName) => {
  return async (dispatch) => {
    dispatch({ type: USER_LOGIN, payload: { ...user, fullName: fullName } });
  }
}

export const isAuthenticated = () => {
  return async (dispatch) => {
    let response = await AuthService.isAuthenticated();
    if (response.message) {
      console.log(response.message)
    }
    else {
      dispatch({ type: IS_AUTHENTICATED, payload: response });
    }

    return response;
  }
};

// Switch the active student for an account with more than two possible students
export const switchAccountStudent = (
  user,
  newUUID,
  newAidYear,
  accountType
) => {
  return async (dispatch) => {
    // Update the token before running the remaining methods in parallel
    await AuthService.updateToken({ claim: "UUID", newValue: newUUID });
    const studentResponse = await StudentService.getStudent(
      newUUID
    );
    const InterviewLinksAllResponse = await StudentService.taskListSearch({
      studentID: studentResponse.student.id,
      newAidYear
    });
    var InterviewLinks = await StudentService.taskListSearch({
      studentID: studentResponse.student.id,
      newAidYear
    }).then((response) => {
      const interviewLinks = response.filter(
        (x) =>
          x.studentInterviewLinkStatus !== "AUTO_VERIFIED" &&
          x.studentInterviewLinkStatus !== "NOT_REQUIRED"
      );
      dispatch({ type: FETCH_INTERVIEW_LINKS, payload: interviewLinks });
      return interviewLinks;
    });
    if (studentResponse.message) {
      console.log(studentResponse.message);
      AlertService.addErrorAlert(studentResponse.message);
    } else {
      InterviewLinks = InterviewLinks.filter(
        (x) =>
          x.studentInterviewLinkStatus !== "AUTO_VERIFIED" &&
          x.studentInterviewLinkStatus !== "NOT_REQUIRED"
      );
      dispatch({ type: FETCH_INTERVIEW_LINKS, payload: InterviewLinks });
      dispatch({
        type: FETCH_INTERVIEW_LINKS_ALL,
        payload: InterviewLinksAllResponse,
      });

      dispatch({ type: UPDATE_AID_YEAR, payload: newAidYear });
      dispatch(fetchIsirRecElementInfo(newAidYear));
      dispatch({
        type: USER_LOGIN,
        payload: { ...user, uuid: newUUID, aidYear: newAidYear },
      });
      dispatch({ type: FETCH_STUDENT, payload: studentResponse });
      history.push(`/studentView/${newUUID}/${accountType}TaskList`);
    }
  };
};

export const verifyCredentials = (username, password) => {
  return async (dispatch) => {
    try {
      await AuthAPI.get("/sso/verifyCredentials");
      const loginResponse = await AuthService.userLogin(username, password);
      dispatch({ type: USER_LOGIN, payload: loginResponse.data });
      history.push(`/${loginResponse.accountType}/${loginResponse.uuid}`);
    } catch (err) { }
  };
};
